"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelInformationStore = void 0;
const api_1 = require("client/api");
const router_1 = require("client/components/router");
const mobx_1 = require("mobx");
class LabelInformationStore {
    constructor() {
        this.loading = false;
        this.name = '';
        this.id = '';
        this.commonBrandNames = '';
        this.drugInteractions = '';
        this.howToUse = '';
        this.important = '';
        this.missedDose = '';
        this.notes = '';
        this.overdose = '';
        this.precautions = '';
        this.sideEffects = '';
        this.storage = '';
        this.uses = '';
        this.ingredients = '';
        this.revisionDate = '';
        this.warning = '';
        this.getItemDescriptions = async (inventoryId) => {
            this.id = inventoryId;
            this.loading = true;
            const result = await api_1.InventoryEndpoint.getItemDescription.apiCall(null, { inventoryId });
            if (api_1.isError(result)) {
                alert('Error');
                return false;
            }
            try {
                // console.log('works');
                const data = result.itemDescriptions[0];
                this.name = data.name;
                this.commonBrandNames = data.commonBrandNames;
                this.drugInteractions = data.drugInteractions;
                this.howToUse = data.howToUse;
                this.important = data.important;
                this.missedDose = data.missedDose;
                this.notes = data.notes;
                this.overdose = data.overDose;
                this.precautions = data.precautions;
                this.sideEffects = data.sideEffects;
                this.storage = data.storage;
                this.uses = data.uses;
                this.ingredients = data.ingredients;
                this.revisionDate = data.revisionDate;
                this.warning = data.warning;
            }
            catch (error) {
                router_1.RouteManager.transitionTo('/formulary');
            }
            this.loading = false;
        };
        this.saveLabelInformation = async () => {
            this.loading = true;
            await api_1.InventoryEndpoint.saveItemDescriptions.apiCall(null, {
                itemDescriptions: {
                    inventoryId: this.id,
                    commonBrandNames: this.commonBrandNames,
                    drugInteractions: this.drugInteractions,
                    howToUse: this.howToUse,
                    important: this.important,
                    missedDose: this.missedDose,
                    notes: this.notes,
                    overdose: this.overdose,
                    precautions: this.precautions,
                    sideEffects: this.sideEffects,
                    storage: this.storage,
                    uses: this.uses,
                    ingredients: this.ingredients,
                    revisionDate: this.revisionDate,
                    warning: this.warning,
                }
            });
            this.loading = false;
        };
    }
}
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "name", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "commonBrandNames", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "drugInteractions", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "howToUse", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "important", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "missedDose", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "notes", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "overdose", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "precautions", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "sideEffects", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "storage", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "uses", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "ingredients", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "revisionDate", void 0);
__decorate([
    mobx_1.observable
], LabelInformationStore.prototype, "warning", void 0);
__decorate([
    mobx_1.action
], LabelInformationStore.prototype, "getItemDescriptions", void 0);
__decorate([
    mobx_1.action
], LabelInformationStore.prototype, "saveLabelInformation", void 0);
exports.labelInformationStore = new LabelInformationStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-label-information/label-information-store.ts
// module id = 3492
// module chunks = 0